import { createSingleAction } from 'store/utils';

export const SET_EDIT_COST_CENTER_ID = 'SET_EDIT_COST_CENTER_ID';
export const setEditCostCenterId = createSingleAction<
string | null, typeof SET_EDIT_COST_CENTER_ID>(SET_EDIT_COST_CENTER_ID);
